var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenSource(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.726,
    height: 102.504,
    viewBox: "0 0 145.726 102.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1290",
    "data-name": "Group 1290",
    transform: "translate(-41.561 1130.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1264",
    "data-name": "Group 1264",
    transform: "translate(41.561 -1130.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    "data-name": "Group 1263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1257",
    "data-name": "Group 1257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    d: "M245.619-996.5h-140.1a2.805 2.805 0 0 1-2.815-2.789v-96.925a2.805 2.805 0 0 1 2.815-2.789h140.1a2.805 2.805 0 0 1 2.815 2.789v96.925a2.805 2.805 0 0 1-2.815 2.789zm-140.1-101.109a1.4 1.4 0 0 0-1.408 1.395v96.925a1.4 1.4 0 0 0 1.408 1.395h140.1a1.4 1.4 0 0 0 1.408-1.395v-96.925a1.4 1.4 0 0 0-1.408-1.395z",
    fill: "#017cee",
    "data-name": "Path 1087",
    transform: "translate(-102.708 1099)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1258",
    "data-name": "Group 1258",
    transform: "translate(1.015 12.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_458",
    d: "M0 0h144.319v1.407H0z",
    fill: "#017cee",
    "data-name": "Rectangle 458"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1262",
    "data-name": "Group 1262",
    transform: "translate(6.321 5.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1259",
    "data-name": "Group 1259"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    cx: 1.672,
    cy: 1.672,
    r: 1.672,
    fill: "#017cee",
    "data-name": "Ellipse 122"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1260",
    "data-name": "Group 1260",
    transform: "translate(10.698)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    cx: 1.672,
    cy: 1.672,
    r: 1.672,
    fill: "#017cee",
    "data-name": "Ellipse 123"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1261",
    "data-name": "Group 1261",
    transform: "translate(5.349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    cx: 1.672,
    cy: 1.672,
    r: 1.672,
    fill: "#017cee",
    "data-name": "Ellipse 124"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1289",
    "data-name": "Group 1289",
    transform: "translate(82.071 -1098.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1281",
    "data-name": "Group 1281",
    transform: "translate(40.194 1.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    d: "M339.141-988.854a7.038 7.038 0 0 0 4.907-1.981 7.015 7.015 0 0 0 2.166-5.091 7.081 7.081 0 0 0-7.073-7.073 7.081 7.081 0 0 0-7.073 7.073 7.024 7.024 0 0 0 2.089 5.018 7.029 7.029 0 0 0 4.984 2.054z",
    fill: "none",
    "data-name": "Path 1095",
    transform: "translate(-332.068 1003)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1282",
    "data-name": "Group 1282",
    transform: "translate(25.437 12.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    d: "M290.129-964.161a7.024 7.024 0 0 0 2.089 5.018 7.016 7.016 0 0 0 4.027 1.983c.084.011.166.029.251.037q.349.035.706.035c.181 0 .359-.012.537-.026.089-.007.178-.014.266-.024a7.031 7.031 0 0 0 4.1-1.931 7.015 7.015 0 0 0 2.166-5.091 7.045 7.045 0 0 0-.323-2.114 7.045 7.045 0 0 0-.583-1.34 7.075 7.075 0 0 0-6.166-3.619 7.08 7.08 0 0 0-6.219 3.706 7.054 7.054 0 0 0-.561 1.364 7.044 7.044 0 0 0-.29 2.002z",
    fill: "none",
    "data-name": "Path 1096",
    transform: "translate(-290.129 971.234)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1283",
    "data-name": "Group 1283",
    transform: "translate(10.779 1.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    d: "M255.546-988.854a7.037 7.037 0 0 0 4.907-1.981 7.015 7.015 0 0 0 2.167-5.091 7.081 7.081 0 0 0-7.073-7.073 7.081 7.081 0 0 0-7.073 7.073 7.024 7.024 0 0 0 2.089 5.018 7.029 7.029 0 0 0 4.983 2.054z",
    fill: "none",
    "data-name": "Path 1097",
    transform: "translate(-248.473 1003)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284",
    transform: "translate(1.411 17.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    d: "M275.49-957.264a11.916 11.916 0 0 1-7.784 2.884 11.894 11.894 0 0 1-6.34-1.821 8.545 8.545 0 0 1 .064 1.024 8.453 8.453 0 0 1-2.6 6.1 8.457 8.457 0 0 1-4.61 2.28 8.543 8.543 0 0 1-1.252.095h-.209a8.493 8.493 0 0 1-1.239-.117 8.458 8.458 0 0 1-4.549-2.342 8.453 8.453 0 0 1-2.505-6.016 8.644 8.644 0 0 1 .056-.96 11.9 11.9 0 0 1-6.233 1.758 11.9 11.9 0 0 1-7.912-2.993c-4.961 4.1-8.21 11.795-8.528 20.271h15.423a23.7 23.7 0 0 1 7.312-10.534.785.785 0 0 1 .48-.164.785.785 0 0 1 .546.221 10.553 10.553 0 0 0 5.332 2.777 10.563 10.563 0 0 0 1.415.175c.2.011.392.018.59.018.144 0 .286 0 .429-.01a10.5 10.5 0 0 0 1.421-.155 10.545 10.545 0 0 0 5.376-2.7.787.787 0 0 1 .539-.214.783.783 0 0 1 .486.169 23.827 23.827 0 0 1 7.164 10.419h15.521c-.313-8.386-3.511-16.042-8.393-20.165z",
    fill: "none",
    "data-name": "Path 1098",
    transform: "translate(-221.851 957.373)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1285",
    "data-name": "Group 1285",
    transform: "translate(16.069 28.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    d: "M287.732-925.5a11.919 11.919 0 0 1-5.617 2.687 11.936 11.936 0 0 1-1.408.171c-.252.016-.5.027-.759.027-.309 0-.615-.014-.92-.038a11.994 11.994 0 0 1-1.4-.19 11.9 11.9 0 0 1-5.59-2.765 22.374 22.374 0 0 0-6.249 9.093q-.273.691-.517 1.407a34.6 34.6 0 0 0-1.763 9.77h32.62a34.594 34.594 0 0 0-1.767-9.77q-.243-.716-.517-1.407a22.525 22.525 0 0 0-6.113-8.985z",
    fill: "none",
    "data-name": "Path 1099",
    transform: "translate(-263.508 925.607)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1286",
    "data-name": "Group 1286",
    transform: "translate(9.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    d: "M252.953-990.039a8.45 8.45 0 0 0 5.883-2.376 8.452 8.452 0 0 0 2.6-6.1 8.48 8.48 0 0 0-8.481-8.48 8.48 8.48 0 0 0-8.48 8.48 8.454 8.454 0 0 0 2.5 6.016 8.454 8.454 0 0 0 5.978 2.46zm0-15.553a7.081 7.081 0 0 1 7.073 7.073 7.015 7.015 0 0 1-2.167 5.091 7.037 7.037 0 0 1-4.907 1.981 7.029 7.029 0 0 1-4.984-2.055 7.024 7.024 0 0 1-2.089-5.018 7.081 7.081 0 0 1 7.074-7.073z",
    fill: "#017cee",
    "data-name": "Path 1100",
    transform: "translate(-244.473 1007)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    "data-name": "Group 1287",
    transform: "translate(0 11.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    d: "M273.358-970.275a.782.782 0 0 0-.486-.169.785.785 0 0 0-.539.214 10.525 10.525 0 0 1-7.226 2.867 10.519 10.519 0 0 1-6.894-2.568 8.482 8.482 0 0 0-7.863-5.3 8.482 8.482 0 0 0-7.91 5.424 10.512 10.512 0 0 1-6.748 2.447 10.53 10.53 0 0 1-7.336-2.969.786.786 0 0 0-.547-.221.784.784 0 0 0-.48.164c-5.4 4.167-9.161 12.3-9.488 21.775a1.3 1.3 0 0 0 1.305 1.344h15.037a36.141 36.141 0 0 0-1.684 9.833 1.3 1.3 0 0 0 1.305 1.344h32.83a1.3 1.3 0 0 0 1.305-1.344 36.146 36.146 0 0 0-1.683-9.834h15.135a1.3 1.3 0 0 0 1.305-1.344c-.323-9.388-4.018-17.462-9.338-21.663zm-23.008-3.552a7.075 7.075 0 0 1 6.166 3.619 7.041 7.041 0 0 1 .583 1.34 7.045 7.045 0 0 1 .323 2.114 7.015 7.015 0 0 1-2.166 5.091 7.031 7.031 0 0 1-4.1 1.931c-.088.01-.177.018-.266.024a6.845 6.845 0 0 1-.537.026q-.356 0-.706-.035c-.084-.008-.167-.026-.251-.037a7.016 7.016 0 0 1-4.027-1.983 7.024 7.024 0 0 1-2.089-5.018 7.044 7.044 0 0 1 .293-2 7.058 7.058 0 0 1 .561-1.364 7.08 7.08 0 0 1 6.216-3.708zm16.18 36.325h-32.62a34.6 34.6 0 0 1 1.763-9.77q.243-.717.517-1.407a22.374 22.374 0 0 1 6.249-9.093 11.9 11.9 0 0 0 5.59 2.765 12 12 0 0 0 1.4.19c.3.023.612.038.92.038.254 0 .507-.011.759-.027a11.935 11.935 0 0 0 1.408-.171 11.919 11.919 0 0 0 5.617-2.687 22.525 22.525 0 0 1 6.112 8.984q.273.691.517 1.407a34.6 34.6 0 0 1 1.767 9.773zm-.764-11.178a23.826 23.826 0 0 0-7.166-10.42.783.783 0 0 0-.486-.169.787.787 0 0 0-.539.214 10.545 10.545 0 0 1-5.376 2.7 10.5 10.5 0 0 1-1.421.155 10.155 10.155 0 0 1-1.019-.008 10.563 10.563 0 0 1-1.415-.175 10.553 10.553 0 0 1-5.332-2.777.785.785 0 0 0-.546-.221.785.785 0 0 0-.48.164 23.7 23.7 0 0 0-7.312 10.534h-15.423c.318-8.476 3.567-16.173 8.528-20.271a11.9 11.9 0 0 0 7.912 2.993 11.9 11.9 0 0 0 6.233-1.758 8.647 8.647 0 0 0-.056.96 8.453 8.453 0 0 0 2.5 6.016 8.458 8.458 0 0 0 4.549 2.342 8.493 8.493 0 0 0 1.239.117h.209a8.543 8.543 0 0 0 1.252-.095 8.457 8.457 0 0 0 4.61-2.28 8.453 8.453 0 0 0 2.6-6.1 8.539 8.539 0 0 0-.064-1.024 11.894 11.894 0 0 0 6.34 1.821 11.915 11.915 0 0 0 7.784-2.884c4.882 4.123 8.08 11.779 8.4 20.161z",
    fill: "#017cee",
    "data-name": "Path 1101",
    transform: "translate(-217.84 975.234)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1288",
    "data-name": "Group 1288",
    transform: "translate(38.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    d: "M336.548-990.039a8.45 8.45 0 0 0 5.883-2.376 8.452 8.452 0 0 0 2.6-6.1 8.48 8.48 0 0 0-8.481-8.48 8.48 8.48 0 0 0-8.48 8.48 8.454 8.454 0 0 0 2.5 6.016 8.454 8.454 0 0 0 5.978 2.46zm0-15.553a7.081 7.081 0 0 1 7.073 7.073 7.015 7.015 0 0 1-2.167 5.091 7.038 7.038 0 0 1-4.907 1.981 7.029 7.029 0 0 1-4.984-2.055 7.024 7.024 0 0 1-2.089-5.018 7.081 7.081 0 0 1 7.074-7.073z",
    fill: "#017cee",
    "data-name": "Path 1102",
    transform: "translate(-328.068 1007)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSource);
export default __webpack_public_path__ + "static/media/OpenSource.bb0463a6cbb522ab0561ebf1286eff4d.svg";
export { ForwardRef as ReactComponent };